import React from "react";

const FileIcon = ({ width = 26.339, height = 33.63, text = "XLS" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26.339 33.63">
    <g transform="translate(-0.223)">
      <path
        d="M1.068,0H16.646l7.375,7.481V32.562a1.068,1.068,0,0,1-1.068,1.068H1.068A1.068,1.068,0,0,1,0,32.562V1.068A1.068,1.068,0,0,1,1.068,0Z"
        transform="translate(2.541)"
        fill="#def8ea"
      />
      <path
        d="M0,0,7.473,7.473h-5.9A1.573,1.573,0,0,1,0,5.9Z"
        transform="translate(19.089)"
        fill="#2bd67b"
      />
      <g transform="translate(0 14.401)">
        <rect width="23" height="10" rx="2" transform="translate(0.223 0.344)" fill="#24b668" />
        <text
          transform="translate(6.223 7.344)"
          fill="#fff"
          fontSize="6"
          fontFamily="Roboto-Bold, Roboto"
          fontWeight="700"
          letterSpacing="0.007em"
        >
          <tspan x="0" y="0">
            {text}
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

export default FileIcon;
